export const LANGUAGE_CHANGED = 'LANGUAGE_CHANGED';
export const ADD_LANGUAGES = 'ADD_LANGUAGES';
export const ADD_REGIONS = 'ADD_REGIONS';
